import React from 'react';
import { cn } from '../../../utils/cn';
import { Field as HeadlessField } from '@headlessui/react';

export default function Field({ children, className }) {
  return (
    <HeadlessField className={cn('flex flex-col gap-2', className)}>
      {children}
    </HeadlessField>
  );
}
